import { render, staticRenderFns } from "./inputTextarea.vue?vue&type=template&id=1cf5cfe0&scoped=true&"
import script from "./inputTextarea.vue?vue&type=script&lang=js&"
export * from "./inputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf5cfe0",
  null
  
)

export default component.exports